import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AgentNames } from '../types';

const THREAD_QUERY_KEY = ['AI', 'THREAD'];

/**
 * Hook to invalidate and refetch threads so sidebar shows updated list/titles.
 * @returns Mutation function to refresh threads
 */
export const useInvalidateThread = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ agentName, threadId }: { agentName: AgentNames; threadId: string }) => {
      await queryClient.invalidateQueries({ queryKey: [...THREAD_QUERY_KEY, agentName, threadId] });
    },
  });
};
